
            const data = {"name":"glyph/12/ticket","data":{"width":"12","height":"12","viewBox":"0 0 12 12","data":"<path pid=\"0\" d=\"M10 6a2 2 0 0 1 2-2V2a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v2a2 2 0 0 1 0 4v2a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V8a2 2 0 0 1-2-2Z\" class=\"nc-icon-wrapper\" _fill=\"#272c33\"/>","originalColors":[{"type":"fill","color":"#272c33"}],"stopColors":[]}}
        
                    module.exports = data
                    